import { render, staticRenderFns } from "./30_main.vue?vue&type=template&id=c2bb759c"
import script from "./30_main.vue?vue&type=script&lang=js"
export * from "./30_main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports